module.exports = __webpack_public_path__ + "img/shuizhuo.e8d2c760.png";